import { useState, useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../home/components/Footer';
import PriceCalculator from '../home/components/PriceCalculator';

export default function PrijsBerekenenPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    // Set page title and meta tags
    document.title = 'Taxi Prijs Berekenen | Utrecht Airport Taxi - Vaste Prijzen';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Bereken direct uw vaste all-in prijs voor een taxi naar Schiphol, Rotterdam Airport of Eindhoven Airport. Geen verborgen kosten, geen verrassingen. Transparante prijzen vanaf €65.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'taxi prijs berekenen, taxi utrecht prijs, kosten taxi schiphol, prijscalculator taxi');
    }
    
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://www.utrechtairporttaxi.nl/prijs-berekenen');
    }

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation isScrolled={isScrolled} />

      <section className="pt-32 pb-12 bg-gradient-to-br from-slate-900 to-slate-800">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold text-white mb-6">
            Taxi Utrecht Schiphol Prijs Berekenen
          </h1>
          <p className="text-xl text-slate-300 leading-relaxed">
            Bereken direct uw vaste all-in prijs voor een taxi naar Schiphol, Rotterdam Airport of Eindhoven Airport. Geen verborgen kosten, geen verrassingen.
          </p>
        </div>
      </section>

      <PriceCalculator />

      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Hoe Werkt Onze Prijscalculator?</h2>
            
            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              Met onze <strong>taxi prijs calculator</strong> berekent u binnen enkele seconden de exacte prijs voor uw luchthaventrip. Selecteer uw vertrekplaats, kies uw bestemming (Schiphol, Rotterdam Airport of Eindhoven Airport), geef het aantal personen op en voeg eventuele extra's toe. U ziet direct de totaalprijs – wat u ziet is wat u betaalt.
            </p>

            <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Vaste Prijzen per Route</h3>
            
            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              Wij werken met vaste prijzen per route. Dit betekent dat de prijs niet afhankelijk is van verkeersdrukte, reistijd of het tijdstip van de dag. Of u nu om 3 uur 's nachts of om 3 uur 's middags vertrekt, de prijs blijft hetzelfde. Geen nachttoeslagen, geen weekendtoeslagen, geen verrassingen.
            </p>

            <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Toegestane Extra's</h3>
            
            <p className="text-lg text-slate-700 leading-relaxed mb-4">
              Naast de basisprijs kunt u de volgende extra's toevoegen:
            </p>

            <ul className="list-disc pl-6 mb-6 text-lg text-slate-700 space-y-2">
              <li><strong>Stationwagon:</strong> +€7,50 (voor extra bagage of meer ruimte)</li>
              <li><strong>Kinderzitje:</strong> €5,00 per stuk (voor kinderen tot 12 jaar)</li>
              <li><strong>Extra tussenstop:</strong> +€7,50 (bijvoorbeeld om iemand op te halen)</li>
            </ul>

            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              Reist u met 5 of meer personen? Dan wordt automatisch een taxibus ingezet, zonder extra toeslag. Onze taxibussen bieden plaats aan 5-8 personen met ruime bagageruimte.
            </p>

            <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Waarom Vaste Prijzen?</h3>
            
            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              Traditionele metertaxi's rekenen per kilometer en per minuut wachttijd. Dit kan leiden tot onverwacht hoge kosten, vooral bij files of vertraging. Wij vinden dat u vooraf moet weten wat u betaalt. Daarom werken wij met transparante vaste prijzen. U boekt met vertrouwen, wetende dat de prijs niet zal veranderen.
            </p>

            <div className="bg-amber-50 border-l-4 border-amber-500 p-6 my-8">
              <h4 className="text-xl font-bold text-slate-900 mb-3">Voorbeeldprijzen naar Schiphol</h4>
              <ul className="space-y-2 text-slate-700 mb-0">
                <li>Utrecht Centrum → Schiphol: €65,00</li>
                <li>Nieuwegein → Schiphol: €67,50</li>
                <li>Houten → Schiphol: €70,00</li>
                <li>Zeist → Schiphol: €72,50</li>
                <li>Maarssen → Schiphol: €67,50</li>
              </ul>
            </div>

            <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Direct Boeken na Berekening</h3>
            
            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              Zodra u uw prijs heeft berekend, kunt u direct online reserveren. Klik op "Reserveer Nu", vul uw contactgegevens en vluchtnummer in, en u ontvangt direct een bevestiging per e-mail. Liever telefonisch boeken? Bel ons op <strong>06 1234 5678</strong> – wij zijn 24/7 bereikbaar.
            </p>
          </article>
        </div>
      </section>

      <Footer />
    </div>
  );
}
